<template>
  <vertical-tab
      v-if="type === 'vertical'"
      :tabs="tabs" :icon="icon" :isShowHeader="isShowHeader"
  />
  <setting-vertical-tab
      v-else-if="type === 'setting-vertical'"
      :tabs="tabs" :icon="icon" :verifyShow="verifyShow"
  />
  <horizontal-customized-tab
      v-else-if="type === 'customize'"
      :tabs="tabs"
      :on-refresh="onRefresh"
      v-on="$listeners"
  />
  <horizontal-tab
      v-else
      :tabs="tabs"
      v-on="$listeners"
  />
</template>
<script>
import SettingVerticalTab from "./SettingVerticalTab";
import HorizontalTab from "./HorizontalTab";
import HorizontalCustomizedTab from "./HorizontalCustomizedTab";
import VerticalTab from "./VerticalTab";

export default {
  name: "AppTab",
  components: {VerticalTab, HorizontalTab, SettingVerticalTab, HorizontalCustomizedTab},
  props: {
    tabs: {
      type: Array,
      require: true
    },
    type: {
      type: String,
      default: 'vertical'
    },
    icon: {
      type: String
    },
    verifyShow: {
      type: Boolean,
      default: false,
    },
    isShowHeader: {
      type : Boolean,
      default : true
    },
    onRefresh: {
      type: Function,
      default: null,
    }
  }
}
</script>

<style>

</style>

